var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoProdutosAlterados01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1404",
    transform: "translate(5 8.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_937",
    d: "M24.1,5c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-9.4c0-0.4,0.3-0.7,0.6-0.7c0.4,0,0.7,0.3,0.7,0.6 c0,0,0,0,0,0v9.4C24.8,4.7,24.5,5,24.1,5L24.1,5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_938",
    d: "M24.1-4.4H11.3c-0.4,0-0.7-0.3-0.6-0.7c0-0.4,0.3-0.6,0.6-0.6h12.8c0.4,0,0.7,0.3,0.6,0.7 C24.7-4.7,24.4-4.5,24.1-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_939",
    d: "M12.7-3.1c-0.2,0-0.3-0.1-0.5-0.2l-1.3-1.3c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,0.7-0.3,1,0l1.3,1.3 c0.3,0.3,0.3,0.7,0,1C13-3.2,12.8-3.1,12.7-3.1L12.7-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_940",
    d: "M11.3-4.4c-0.4,0-0.7-0.3-0.7-0.7c0-0.2,0.1-0.3,0.2-0.5l1.3-1.3c0.3-0.3,0.7-0.2,0.9,0 c0.2,0.3,0.2,0.7,0,0.9l-1.3,1.3C11.7-4.5,11.5-4.4,11.3-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_941",
    d: "M1.9,24.5c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-9.4c0-0.4,0.3-0.7,0.6-0.7c0.4,0,0.7,0.3,0.7,0.6 c0,0,0,0,0,0v9.4C2.6,24.2,2.3,24.5,1.9,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_942",
    d: "M14.7,24.5H1.9c-0.4,0-0.7-0.3-0.6-0.7c0-0.4,0.3-0.6,0.6-0.6h12.8c0.4,0,0.7,0.3,0.6,0.7 C15.3,24.2,15,24.4,14.7,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_943",
    d: "M14.7,24.5c-0.2,0-0.3-0.1-0.5-0.2l-1.3-1.3c-0.3-0.3-0.3-0.7,0-0.9c0.3-0.3,0.7-0.3,0.9,0c0,0,0,0,0,0 l1.3,1.3c0.3,0.3,0.3,0.7,0,1C15,24.4,14.8,24.5,14.7,24.5L14.7,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_944",
    d: "M13.3,25.8c-0.4,0-0.7-0.3-0.7-0.7c0-0.2,0.1-0.3,0.2-0.5l1.3-1.3c0.3-0.3,0.7-0.2,0.9,0 c0.3,0.3,0.2,0.7,0,0.9l-1.3,1.3C13.7,25.7,13.5,25.8,13.3,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_945",
    d: "M10.2-1.7L3.2-4.8c-0.1,0-0.2,0-0.4,0l-7.1,3.1c-0.2,0.1-0.3,0.2-0.3,0.4v8.8c0,0.2,0.1,0.3,0.2,0.4 l7.1,3.6c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0L10.3,8c0.2-0.1,0.2-0.2,0.2-0.4v-8.9C10.5-1.4,10.4-1.6,10.2-1.7z M3-3.9l6,2.6 L3,1.3L1.4,0.7l2.4-1C4-0.5,4.1-0.7,4-0.9C4-1,3.9-1.1,3.8-1.2L1.9-2c-0.1,0-0.2,0-0.4,0l-3.1,1.4L-3-1.3L3-3.9z M-1,0.6L-0.1,1 v1.9L-1,2.4V0.6z M-0.5-0.2l2.2-1l0.8,0.3l-2.2,1L-0.5-0.2z M-3.6-0.6l1.8,0.8v2.5c0,0.2,0.1,0.3,0.2,0.4L0.1,4 c0.2,0.1,0.5,0,0.6-0.2c0-0.1,0-0.1,0-0.2V1.3l1.8,0.8v8.3l-6.2-3.1V-0.6z M3.4,10.4V2.1l6.2-2.7v7.9L3.4,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_946",
    d: "M30.2,10.8l-7.1-3.1c-0.1,0-0.2,0-0.4,0l-7.1,3.1c-0.2,0.1-0.3,0.2-0.3,0.4V20c0,0.2,0.1,0.3,0.2,0.4 l7.1,3.6c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l7.1-3.6c0.1-0.1,0.2-0.2,0.2-0.4v-8.9C30.5,11,30.4,10.8,30.2,10.8z M23,8.6l6,2.6 l-6,2.6l-1.5-0.7l2.4-1c0.2-0.1,0.3-0.3,0.2-0.6c0-0.1-0.1-0.2-0.2-0.2l-1.9-0.8c-0.1,0-0.2,0-0.4,0l-3.1,1.4L17,11.2L23,8.6z  M19,13l0.9,0.4v1.9L19,14.9V13z M19.6,12.3l2.2-1l0.8,0.3l-2.2,1L19.6,12.3z M16.4,11.8l1.8,0.8v2.5c0,0.2,0.1,0.3,0.2,0.4 l1.8,0.9c0.2,0.1,0.5,0,0.6-0.2c0-0.1,0-0.1,0-0.2v-2.3l1.8,0.8v8.3l-6.2-3.1L16.4,11.8z M23.4,22.9v-8.3l6.2-2.7v7.9L23.4,22.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProdutosAlterados01);
export default __webpack_public_path__ + "static/media/ico-produtos-alterados-01.8b1045a7bcfc93ad32b3570c627e3e61.svg";
export { ForwardRef as ReactComponent };